import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";


const adminFields = `
id
adminProfile {
  id
  profileUniqueId
  userFirstName
  userLastName
  userEmail
  profilePhone
  profileTitle
  profilePhoto
  profileIsActive
  profileType
}
adminInstitution {
  id
  institutionUniqueId
  institutionName
  institutionShortform
  institutionPhysicalAddress
  institutionEmail
  institutionPostcode
  institutionWebsite
  institutionPhones
  institutionMapUrl
  institutionLogo
  institutionMinistry {
    id
    ministryUniqueId
    ministryName
  }
  institutionSector {
    id
    sectorUniqueId
    sectorName
    sectorIcon
  }
}
adminRoles {
  id
  roleUniqueId
  roleName
  roleIsAdmin
  roleIsSystemDefault
  roleDescription
  rolePermissions {
    id
    permissionUniqueId
    permissionName
    permissionCode
  }
}
`;

const userFields = `
      id
      profile {
        id
        profileUniqueId
        userFirstName
        userLastName
        userEmail
        profilePhone
        profileTitle
        profilePhoto
        profileIsDeactivated
        profileType
      }
      userDesignation {
        id
        designationUniqueId
        designationShortForm
        designationName
      }
      role {
        id
        roleUniqueId
        roleName
        roleIsAdmin
        roleIsSystemDefault
        roleDescription
        rolePermissions {
          id
          permissionUniqueId
          permissionName
          permissionCode
        }
      }
`;
export const CREATE_INSTITUTION_ADMINISTRATOR = gql`
    mutation CreateInstitutionAdminstrators($input: InstitutionAdminInputObject!) {
        createInstitutionAdminstrators(input: $input) {
            data{
                ${adminFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const UPDATE_INSTITUTION_ADMINISTRATOR = gql`
    mutation UpdateInstitutionAdminstrators($input: InstitutionAdminInputObject!) {
        updateInstitutionAdminstrators(input: $input) {
            data{
                ${adminFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const GET_ALL_INSTITUTIONS = gql`
    query GetInstitutionUsers($filtering: UserFilteringInputObject!) {
        getInstitutionUsers(filtering: $filtering) {
            data{
                ${userFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const DELETE_INSTITUTION_ADMINISTRATOR = gql`
    mutation DeleteInstitutionAdminstrators($profileUniqueId: String!) {
        deleteInstitutionAdminstrators(profileUniqueId: $profileUniqueId) {
            response{
                ${baseResponse}
            }
        }
    }
`;
